import SelectItemModal from 'template/Modals/SelectItem';
import getCurrentTeacher from 'controllers/teacher/getCurrentTeacher'
import Teacher from 'mediators/Teacher';

//
// User can select a teacher
// a wraper of SelectItemModal
//
// eg.
// SelectTeacher({ schoolId })
//  .then()
//  .catch()
//
export default function(opts) {
  const {
    schoolId,
    selectMultiple,
    amount_per_page = 25,
  } = opts;

  // this will return a promise
  return SelectItemModal({
    headerTitle: __('Select Teacher', 'schedule'),
    headerIcon: 'fa icon-chalkboard-teacher',
    itemName: __('Teacher', 'schedule'),
    searchPlaceholder: __('Search Teacher', 'schedule'),
    selectMultiple: selectMultiple,
    showName: true,
    
    backendSearch: true,
    
    getItemLabel: (teacher)=>{
      return teacher.name || teacher.tName;
    },
    fetchItems: (cb, fetchOpts)=>{
      const {
        searchKeyword,
        currentPageNumber,
      } = fetchOpts;

      getCurrentTeacher({
        schoolId,
        current_page_number: currentPageNumber,
        keyword: searchKeyword,
        amount_per_page,
      })
        .then((data)=>{
          const { 
            list,
            page_amount,
          } = data;
          
          const pageMeta = {
            maxPageNumber: page_amount,
          };
          
          const teacherObjs = list.map((raw)=>{
            return new Teacher(raw);
          });

          cb(teacherObjs, pageMeta);
        })
        .catch((err)=>{ console.error(err); });
    },
    selectFilter: (item, alreadySelected, selected)=>{
      return alreadySelected.id == item.id;
    },


    ...opts,

  })
}



// WEBPACK FOOTER //
// ./src/template/Modals/SelectTeacher/index.js